const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

export const getMonthLabel = (mes) => {
        if (mes === null || mes === undefined || mes === '') {
            return 'Mês não informado';
        }

        const monthIndex = parseInt(mes, 10) - 1;
        if (Number.isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) {
            return String(mes);
        }

        return monthNames[monthIndex] || mes;
    };